/* ============================================
   CONTACT.JSX - FIXED VERSION
   📁 File location: src/pages/Contact.jsx
   ✅ Proper spacing, no scroll indicator
   ============================================ */

import React, { useContext, useState } from "react";
import { User, Mail, Phone, ChevronDown } from "lucide-react";
import "../../../assets/css/Buyer/contactus/contactus.css";
import MyNavbar from "components/Buyer/navbar/MyNavbar";
import Footer from "components/Buyer/footer/Footer";
import { FaArrowRight } from "react-icons/fa";
import AboutFaqs from "subscreens/Buyer/aboutus/AboutFaqs";
import HeroSection from "subscreens/general/pageheros/HeroSection";
import axios from "axios";
import AppContext from "context/AppContext";
import Swal from "sweetalert2";

const Contact = () => {
  const { baseUrl ,authToken} = useContext(AppContext);
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const [phone, setPhone] = useState();
  const [location, setLocation] = useState();
  const [email, setEmail] = useState();
  const [message, setMessage] = useState();

  const createContact = () => {
    console.log(
      "********contact form log",
      firstName,
      lastName,
      phone,
      location,email,message,
    );
    const formData = new FormData();
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("phone", phone);
    formData.append("location", location);
    formData.append("email", email);
    formData.append("message", message);
    axios
      .post(`${baseUrl}/buyer/contact/createcontact`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then((response) => {
        console.log(response.data);

         Swal.fire({
         title: 'Success!',
         text: 'Message Sent Successfully',
         icon: 'success',
        confirmButtonText: 'OK'
   });
        setFirstName("");
        setLastName("");
        setPhone("");
        setLocation("");
        setEmail("");
        setMessage("");
      })
      .catch((error) => {
        console.log(error);
          Swal.fire({
         title: 'Error!',
         text: 'Something went wrong',
         icon: 'error',
         confirmButtonText: 'OK'
   });
      });
  };
  
  

  return (
    <>
      <MyNavbar />
      <div className="contact-page-wrapper">
        {/* ========================================
           HERO SECTION - NO SCROLL INDICATOR
           ======================================== */}
        <section className="contact-hero-section">
          <HeroSection
            title="Contact"
            subtitle="Let's talk about your next project"
            image="https://images.unsplash.com/photo-1449824913935-59a10b8d2000?w=1920"
          />
        </section>

        <section className="contact-section">
          <div className="contact-container">
            {/* ========================================
                   LEFT SECTION - Info + Social + Image
                   ======================================== */}
            <div className="contact-left">
              {/* Contact Us label */}
              <div className="contact-label">
                <span className="dot">●</span> CONTACT US
              </div>

              {/* Main heading */}
              <h2 className="contact-heading">
                Complete this form
                <br />
                to contact our team
              </h2>

              {/* Follow Us section */}
              <div className="follow-section">
                <p className="follow-label">FOLLOW US:</p>

                {/* Social icons */}
                <div className="social-icons">
                  {/* TikTok */}
                  <a
                    href="https://tiktok.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label="TikTok"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
                    </svg>
                  </a>

                  {/* Instagram */}
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label="Instagram"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </a>

                  {/* Twitter */}
                  <a
                    href="https://twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-icon"
                    aria-label="Twitter"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                    </svg>
                  </a>
                </div>
              </div>

              {/* City image */}
              <div className="city-image">
                <img
                  src="https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop"
                  alt="Dubai Skyline"
                />
              </div>
            </div>

            {/* ========================================
                   RIGHT SECTION - Contact Form
                   ======================================== */}
            <div className="contact-right">
              <form className="contact-form">
                {/* First Name & Last Name - 2 columns */}
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      name="firstName"
                      value={firstName}
                      onChange={(e) => {
                        setFirstName(e.target.value);
                      }}
                      placeholder="First Name*"
                      required
                      className="contactform-input"
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="lastName"
                      value={lastName}
                      onChange={(e) => {
                        setLastName(e.target.value);
                      }}
                      placeholder="Last Name*"
                      required
                      className="contactform-input"
                    />
                  </div>
                </div>

                {/* Phone Number */}
                <div className="form-group">
                  <input
                    type="phone"
                    name="phone"
                    value={phone}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                    placeholder="Phone Number*"
                    required
                    className="contactform-input"
                  />
                </div>

                {/* Email Address */}
                <div className="form-group">
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    placeholder="Email Address*"
                    required
                    className="contactform-input"
                  />
                </div>

                {/* Location dropdown */}
                <div className="form-group">
                  <select
                    name="location"
                    value={location}
                    onChange={(e) => {
                      setLocation(e.target.value);
                    }}
                    required
                    className="contactform-input contactform-select"
                  >
                    <option value="">Location</option>
                    <option value="karachi">Karachi</option>
                    <option value="lahore">Lahore</option>
                    <option value="islamabad">Islamabad</option>
                    <option value="dubai">Dubai</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                {/* Message textarea */}
                <div className="form-group">
                  <textarea
                    name="message"
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    placeholder="Message"
                    rows="6"
                    className="contactform-input contactform-textarea"
                  ></textarea>
                </div>
              </form>

              <button
              type="button"
              className="explore-btn"
              onClick={createContact}
              > 
              <span>Submit</span>
               <div className="btn-icon">
                  <FaArrowRight />
                </div>
              </button>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <AboutFaqs subtitle="FAQ" title="Frequently Asked Questions" />

        {/* ========================================
           ADDRESS SECTION
           ======================================== */}
        <section className="contact-address-section">
          <div className="address-grid-container">
            <div className="address-block">
              <h3 className="address-block-title">Postal Address</h3>
              <p className="address-block-text">
                PO Box 16122 Collins Street West
                <br />
                Victoria 8007 Australia
              </p>
            </div>

            <div className="address-block">
              <h3 className="address-block-title">Envato HQ</h3>
              <p className="address-block-text">
                121 King Street, Melbourne
                <br />
                Victoria 3000 Australia - Map
              </p>
            </div>

            <div className="address-block">
              <h3 className="address-block-title">Business Phone</h3>
              <p className="address-block-text">
                +61 3 8376 6284
                <br />
                +44 3 7890 - 69
              </p>
            </div>
          </div>
        </section>

        {/* ========================================
           MAP SECTION
           ======================================== */}
        <section className="contact-map-section">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509374!2d144.95373631531654!3d-37.81720997975195!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4c2b349649%3A0xb6899234e561db11!2sEnvato!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            title="Location Map"
            className="contact-map-iframe"
          ></iframe>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
